import { plainToInstance } from 'class-transformer'

import { GET_STICKER_LIST } from '@client/collections/Sticker/schemas/getStickerList'
import { gqlApiInstance } from '@client/init'
import { SortEnum } from '@interfaces/SortEnum'
import { GetStickerListResponse } from '@models/sticker/GetStickerListResponse'

export function useStickerAction() {
  async function getStickerList({
    page,
    perpage,
  }: {
    page: number
    perpage: number
  }): Promise<GetStickerListResponse> {
    const { stickers } = await gqlApiInstance.request(GET_STICKER_LIST, {
      page,
      limitPerPage: perpage,
      orderBy: { createdAt: SortEnum.DESC },
    })

    return plainToInstance(GetStickerListResponse, stickers)
  }

  return {
    getStickerList,
  }
}
